import { AiFillInstagram } from 'react-icons/ai';
import styled from '@emotion/styled';
import { DARK_GRAY } from '../../../styles/constants/color';

const Button = styled.button`
  width: auto;
  height: auto;
  text-align: center;
`;

interface Props {
  color?: string;
}

/**
 *  쏠카 인스타그램 새창 버튼 컴포넌트
 * @param {string} color 버튼의 색깔 defalut: #666;
 *  */
function ScInstagram({ color }: Props): JSX.Element {
  const onClick = (): void => {
    window.open('https://www.instagram.com/solecar5012/');
  };
  return (
    <Button onClick={onClick}>
      <AiFillInstagram size={30} color={color || DARK_GRAY} />
    </Button>
  );
}

export default ScInstagram;
